const primaryMain = '#774EFF';
const secondaryMain = '#FBB500';
const pointMain = '#4BCDFF';
const errorMain = '#FE3F61';
const successMain = '#009846';
const warningMain = '#FF6711';
const gradientPrimaryMain = {
  color: '#14142B',
  background: 'linear-gradient(90deg, #74CFFF -3.66%, #7252FD 57.12%, #995279 123.17%)'
};
const background = '#F8F8F8';
const white = '#fff';
const gray100 = '#F8F8F8';
const gray170 = 'rgba(240, 240, 240, 0.7)';
const gray200 = '#F0F0F0';
const gray300 = '#DCDCDC';
const gray400 = '#888888';
const gray500 = '#555555';
const gray600 = '#333333';
const black = '#0F0F0F';

export const colorSet = {
  primaryMain,
  secondaryMain,
  pointMain,
  errorMain,
  successMain,
  warningMain,
  gradientPrimaryMain,
  background,
  white,
  gray100,
  gray170,
  gray200,
  gray300,
  gray400,
  gray500,
  gray600,
  black
};
